import { render, staticRenderFns } from "./UjianMapelFilter.vue?vue&type=template&id=2b85a06a&scoped=true"
import script from "./UjianMapelFilter.vue?vue&type=script&lang=js"
export * from "./UjianMapelFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b85a06a",
  null
  
)

export default component.exports